var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.19,
    height: 23.41,
    viewBox: "0 0 24.19 23.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.951,21.194H12.1v-.781H1.951A1.171,1.171,0,0,1,.78,19.243V2.076A1.17,1.17,0,0,1,1.951.905H19.118a1.17,1.17,0,0,1,1.171,1.171V11.05h.781V2.076A1.953,1.953,0,0,0,19.118.125H1.951A1.953,1.953,0,0,0,0,2.076V19.243A1.954,1.954,0,0,0,1.951,21.194Zm0,0",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.344,62.469h.78v.78h-.78Zm0,0",
    transform: "translate(-60.783 -60.783)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.676,62.469h.781v.78h-.781Zm0,0",
    transform: "translate(-121.555 -60.783)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.016,62.469h.78v.78h-.78Zm0,0",
    transform: "translate(-182.334 -60.783)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.344,124.8H80.291v.781H62.344Zm0,0",
    transform: "translate(-60.783 -121.555)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,191.707l-.991.991a1.957,1.957,0,1,0,.552.552l.991-.991Zm-2.065,3.787a1.17,1.17,0,1,1,0-2.341,1.15,1.15,0,0,1,.5.117l-.777.777.552.552.778-.777a1.149,1.149,0,0,1,.117.5A1.17,1.17,0,0,1,63.836,195.494Zm0,0",
    transform: "translate(-60.325 -186.786)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,249.484h6.633v.78h-6.633Zm0,0",
    transform: "translate(-258.308 -243.116)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,311.82h2.731v.78h-2.731Zm0,0",
    transform: "translate(-258.308 -303.892)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,311.82h5.462v.78H405.2Zm0,0",
    transform: "translate(-395.059 -303.892)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.047,249.484h3.9v.78h-3.9Zm0,0",
    transform: "translate(-547.001 -243.116)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,378.723l-.991.991a1.957,1.957,0,1,0,.552.552l.991-.991Zm-2.065,3.787a1.171,1.171,0,0,1,0-2.341,1.152,1.152,0,0,1,.5.117l-.777.777.552.552.778-.777a1.15,1.15,0,0,1,.117.5A1.17,1.17,0,0,1,63.836,382.51Zm0,0",
    transform: "translate(-60.325 -369.12)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,436.492h6.633v.78h-6.633Zm0,0",
    transform: "translate(-258.308 -425.442)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,498.836h2.731v.78h-2.731Zm0,0",
    transform: "translate(-258.308 -486.226)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,498.836h3.121v.78H405.2Zm0,0",
    transform: "translate(-395.059 -486.226)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.047,436.492h1.561v.78h-1.561Zm0,0",
    transform: "translate(-547.001 -425.442)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,565.738l-.991.991a1.957,1.957,0,1,0,.552.552l.991-.991Zm-2.065,3.787a1.171,1.171,0,0,1,0-2.341,1.149,1.149,0,0,1,.5.117l-.777.777.552.552.778-.777a1.15,1.15,0,0,1,.117.5A1.17,1.17,0,0,1,63.836,569.525Zm0,0",
    transform: "translate(-60.325 -551.453)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,623.512h5.072v.78h-5.072Zm0,0",
    transform: "translate(-258.308 -607.78)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.941,685.852h2.731v.78h-2.731Zm0,0",
    transform: "translate(-258.308 -668.56)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,685.852h1.561v.78H405.2Zm0,0",
    transform: "translate(-395.059 -668.56)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.564,479.369a5.853,5.853,0,1,0-5.853-5.853A5.852,5.852,0,0,0,504.564,479.369Zm0-10.925a5.072,5.072,0,1,1-5.072,5.072A5.072,5.072,0,0,1,504.564,468.444Zm0,0",
    transform: "translate(-486.226 -455.834)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.218,584.547l-.7.349.78,1.561a.39.39,0,0,0,.287.211.439.439,0,0,0,.061.005.391.391,0,0,0,.276-.114l4.682-4.682-.552-.552-4.3,4.3Zm0,0",
    transform: "translate(-594.26 -566.648)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.05ce6964.svg";
export { ForwardRef as ReactComponent };